import React from 'react';
import { Container } from '@chakra-ui/react';
import {Text} from '@chakra-ui/react'
import { Link } from 'react-router-dom';


const Footer = () => {
  return (
    <Container textAlign={'center'} maxW="container.lg" py={4}>
      <Text fontSize={'0.7vw'}>
       BROUGHT TO YOU BY CROHAM CITY ICCW RECKLESS OVERSEER,  2024.
         <Link to='../bank'> ...</Link>
      </Text>
    </Container>
  );
};

export default Footer;
